import type { CatalogueRow } from './types'

export interface CatalogueScopeGroup extends CatalogueRow {
  id: string
  showName: boolean
  scopes: { id: string; label: string; row: CatalogueRow }[]
}

/** Group definitions by binding name while retaining each scope's metadata. */
export function groupCatalogueRows(
  rows: CatalogueRow[]
): CatalogueScopeGroup[] {
  const names = new Map<string, Map<string, CatalogueScopeGroup>>()
  for (const row of rows) {
    if (!row.scope) throw new Error('Catalogue fact is missing its scope')
    let variants = names.get(row.name)
    if (!variants) {
      variants = new Map()
      names.set(row.name, variants)
    }
    const key = JSON.stringify([row.source, row.types, row.definition])
    let group = variants.get(key)
    if (!group) {
      group = {
        ...row,
        id: JSON.stringify([row.name, key]),
        showName: variants.size === 0,
        scopes: [],
      }
      variants.set(key, group)
    }
    const scope =
      row.scope === 'duty'
        ? { id: `duty:${row.dutyId}`, label: `Duty: ${row.dutyName}` }
        : {
            id: row.scope,
            label: row.scope === 'org' ? 'Organization' : row.scope,
          }
    if (!group.scopes.some((existing) => existing.id === scope.id))
      group.scopes.push({ ...scope, row })
  }
  return [...names.values()].flatMap((variants) => [...variants.values()])
}
